import React ,{useEffect, useState, useCallback} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import defaultStyles from './exportCommodityReport.module.scss';
import GridHeader from '../../common/gridheader/GridHeader';
import Grid from '../../webcommon/grid/Grid';
import { refreshReportData, exportConnected , setActiveValue, setRowChecked, setAllRowsChecked, exportReports,setGridSorts} from '../actions';
import {combinedColumnsSelector, getRows, getDefaultSort} from '../selectors'
import SimpleGridHeaderButton from '../../common/gridheader/simplegridheader/SimpleGridHeaderButton';
import { ReactComponent as Export } from '../../webcommon/common/Icons/Export.svg';
import Modal from '../../webcommon/common/modal/Modal';
import { findGridSort } from "../../common/helpermethods/HelperMethods"

const ExportCommodityReport = (props)=> {

    const {exportConnected, location, setAllRowsChecked, exportReports} = props;    
    

    useEffect(() => {
        exportConnected(location.search);
    },[exportConnected, location]); 

    const [modalOpen, toggleModal] = useState(false);
    const [allRowsChecked, setAllRowsCheckedFunc] = useState(false);

    const setHeaderChecked = useCallback((checked) => {
        setAllRowsChecked(checked);
        setAllRowsCheckedFunc(checked);
    }, [setAllRowsChecked, setAllRowsCheckedFunc]);  

    
    let atLeastOneReportChecked = props.rows.some(row => row.selected)
    let reportsSelected = props.rows.filter( row => row.selected).map(row => row.id)

    return (
            <div className={props.styles.wrapper}>
                <div className={props.styles.gridWrapper}>
                    <div className={props.styles.gridHeaderContainer}>
                        <GridHeader
                            title="Reports Available" 
                            refreshControlsActive
                            refreshData={ props.refreshReportData }                                                      
                        >{atLeastOneReportChecked &&
                            <SimpleGridHeaderButton
                                onClick={ () => {exportReports(reportsSelected)} }
                                text="Export Report"                                
                            >
                                <Export />
                            </SimpleGridHeaderButton>}
                        {!atLeastOneReportChecked &&
                            <SimpleGridHeaderButton
                                onClick={ () => {} }
                                text="Please select at least one report to export"                                
                            >                                
                            </SimpleGridHeaderButton>}
                        </GridHeader>                                            
                    </div>
                    <div className={props.styles.modal}>                    
                        <Modal
                            isOpen={modalOpen}
                            closeModal= {() => toggleModal(!modalOpen)}>                          
                            <div className={props.styles.dropZoneWrapper}>
                            </div>
                        </Modal>  
                </div>
                    <div className={props.styles.grid}>
                    <Grid
                        sortable
                        columns={props.columns}
                        rows={props.rows}
                        loading={ props.loading }
                        headerChecked={ allRowsChecked }
                        setHeaderChecked={ setHeaderChecked }
                        setRowChecked={ props.setRowChecked }
                        defaultSorted={ findGridSort(props.defaultSort,
                            'timestampSort') }
                        onSortedChange={ (newSorted) => {
                                props.setGridSorts('timestampSort', newSorted);
                            } }
                    />
                    </div>
                </div>                
            </div>                 
            ); 
}
ExportCommodityReport.propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string
    }).isRequired,
    exportConnected: PropTypes.func.isRequired,
    styles: PropTypes.objectOf(PropTypes.string),
};

ExportCommodityReport.defaultProps = {
     styles: defaultStyles,
     dateProp: '',
};

const mapDispatchToProps = {
    exportConnected,
    refreshReportData,
    setActiveValue,
    setRowChecked,
    setAllRowsChecked,
    exportReports,
    setGridSorts,
};

const mapStateToProps = state => ( 
    {   
        columns: combinedColumnsSelector(state),
        rows: getRows(state),
        defaultSort: getDefaultSort(state),
    }
    )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ExportCommodityReport));
